import { Services } from '@sigma-frontend-libs/commons'

import { components, labelModes } from '@/utils'

import buttonFilter from '@/components/button/filter'
import selectorOwner from '@/components/selector/owner'
import signMethod from '@/components/services/contracts/commons/signMethod'

function renderSignMethodField(h) {
  return h(
    signMethod,
    {
      props: {
        value: this.proxy.signMethod,
        labelMode: labelModes.hidden
      },
      on: {
        input: event => {
          this.proxy.signMethod = event
        }
      }
    }
  )
}
function renderOwnerField(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        labelMode: labelModes.hidden,
        dense: true,
        rounded: true,
        details: false,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}
function renderRequisiteField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.RequisiteId,
        label: this.getTranslate(`${Services.contracts}.labels.requisite`),
        service: Services.requisites,
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true,
        autocomplete: true
      },
      on: {
        input: event => {
          this.proxy.RequisiteId = event
        }
      }
    }
  )
}
function renderCompanyField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.CompanyId,
        label: this.getTranslate(`${Services.contracts}.labels.company`),
        service: Services.companies,
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true,
        autocomplete: true
      },
      on: {
        input: event => {
          this.proxy.CompanyId = event
        }
      }
    }
  )
}
function renderFields(h) {
  return [
    renderSignMethodField.call(this, h),
    renderOwnerField.call(this, h),
    renderRequisiteField.call(this, h),
    renderCompanyField.call(this, h)
  ]
}

function renderButtonFilter(h) {
  return h(
    buttonFilter,
    {
      props: {
        value: this.proxy,
        defaultValue: this.defaultFilter
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    renderFields.call(this, h)
  )
}

function renderContentByViewport(h) {
  if (this.viewport.breakpoint.lgUp) {
    return renderButtonFilter.call(this, h)
  } else {
    return h(
      'div',
      {
        class: 'grid grid-gap--8'
      },
      renderFields.call(this, h)
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.contracts}-filter`
    },
    [ renderContentByViewport.call(this, h) ]
  )
}
